export enum ORG_ACCESS_LEVELS {
  DISABLED = 'disabled',
  VIEWER = 'viewer',
  USER = 'user',
  ADMIN = 'admin',
  SUPERADMIN = 'superadmin'
}

export default ORG_ACCESS_LEVELS;
